import "core-js/modules/es.array.concat.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "review-page"
  }, [_c("header", {
    staticClass: "page-header"
  }, [_c("h1", [_vm._v(_vm._s(_vm.platformName) + "审核结果")]), !_vm.initialLoading && !_vm.pageError ? _c("p", [_vm._v("共 " + _vm._s(_vm.total) + " 条作品未合格")]) : _vm._e()]), _c("main", {
    staticClass: "page-content"
  }, [_vm.initialLoading ? _c("div", {
    staticClass: "state-panel"
  }, [_c("van-loading", {
    attrs: {
      color: "#ee0a24",
      size: "28px"
    }
  }, [_vm._v("正在加载审核结果...")])], 1) : _vm.pageError ? _c("div", {
    staticClass: "state-panel error-panel"
  }, [_c("p", [_vm._v(_vm._s(_vm.pageError))]), _vm.queryMode ? _c("van-button", {
    attrs: {
      type: "danger",
      size: "small"
    },
    on: {
      click: _vm.loadFirstPage
    }
  }, [_vm._v(" 重新加载 ")]) : _vm._e()], 1) : _vm.works.length === 0 ? _c("div", {
    staticClass: "state-panel empty-panel"
  }, [_c("div", {
    staticClass: "empty-icon"
  }, [_vm._v("✓")]), _c("h2", [_vm._v("暂无不合格作品")]), _c("p", [_vm._v("本次没有需要查看的不合格作品")])]) : _c("van-list", {
    attrs: {
      finished: _vm.finished,
      "finished-text": _vm.paginationError ? "" : "没有更多了"
    },
    on: {
      load: _vm.loadMore
    },
    model: {
      value: _vm.listLoading,
      callback: function callback($$v) {
        _vm.listLoading = $$v;
      },
      expression: "listLoading"
    }
  }, [_vm._l(_vm.works, function (work, index) {
    return _c("article", {
      key: "".concat(work.workUrl || "work", "-").concat(index),
      staticClass: "work-card"
    }, [_c("div", {
      staticClass: "work-index"
    }, [_vm._v(_vm._s(index + 1))]), _c("div", {
      staticClass: "work-main"
    }, [_c("div", {
      staticClass: "field-row publish-time"
    }, [_c("span", {
      staticClass: "field-label"
    }, [_vm._v("发布时间")]), _c("span", {
      staticClass: "field-value"
    }, [_vm._v(_vm._s(_vm.formatPublishTime(work.publishTime)))])]), _c("div", {
      staticClass: "title-block"
    }, [_c("span", {
      staticClass: "field-label"
    }, [_vm._v("标题")]), _c("h2", [_vm._v(_vm._s(work.title || "无标题"))])]), _c("div", {
      staticClass: "action-row"
    }, [_c("button", {
      staticClass: "text-action danger",
      attrs: {
        type: "button"
      },
      on: {
        click: function click($event) {
          return _vm.showReason(work);
        }
      }
    }, [_vm._v(" 查看原因 ")]), _c("button", {
      staticClass: "text-action",
      class: {
        disabled: !_vm.isValidWorkUrl(work.workUrl)
      },
      attrs: {
        type: "button"
      },
      on: {
        click: function click($event) {
          return _vm.openWork(work.workUrl);
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.isValidWorkUrl(work.workUrl) ? "查看作品" : "作品链接不可用") + " ")])])])]);
  }), _vm.paginationError ? _c("div", {
    staticClass: "pagination-error"
  }, [_c("span", [_vm._v(_vm._s(_vm.paginationError))]), _c("button", {
    attrs: {
      type: "button"
    },
    on: {
      click: _vm.retryPage
    }
  }, [_vm._v("重新加载")])]) : _vm._e()], 2)], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };